// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1RJBU","alert":"SettungsInbox_alert__3gAMA"};